export enum SiteDocumentTypes {
  Folder = 1,
  Document = 2,
  Drawing = 3
}
